import React from "react";
import {Button} from './styles'
function Index({ children, handleClick,toggle }) {
  return (
   <Button onClick={handleClick} toggle={toggle}>{children}</Button>
  );
}

export default Index;
